//support-data-loader.ts

import { useEffect, useState } from "react";
import { SupportCategory } from "../contexts/support-types";
import { supportContentApi } from "../services/api/support-content";

const normalizeSupportData = (
  data: SupportCategory[] | null | undefined,
): SupportCategory[] =>
  (data || []).map((category) => ({
    ...category,
    articles: category.articles || [],
  }));

const loadJsonSupportData = async (): Promise<SupportCategory[]> => {
  const res = await fetch(`/support-data.json?cache=${Date.now()}`);

  if (!res.ok) {
    return [];
  }

  const data = await res.json();

  return normalizeSupportData(data);
};

export const useSupportDataLoader = () => {
  const [supportData, setSupportData] = useState<SupportCategory[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    async function loadSupportContent() {
      try {
        const databaseData = normalizeSupportData(
          await supportContentApi.getAll(),
        );

        if (isMounted && databaseData.length > 0) {
          setSupportData(databaseData);
          setIsLoading(false);
          return;
        }
      } catch (err) {
        console.error("Failed to load database support content", err);
      }

      try {
        const jsonData = await loadJsonSupportData();

        if (isMounted) {
          setSupportData(jsonData);
        }
      } catch (err) {
        console.error("Failed to load support-data.json", err);
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    }

    loadSupportContent();

    return () => {
      isMounted = false;
    };
  }, []);

  return { supportData, setSupportData, isLoading };
};
